"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const toolkit_1 = require("@reduxjs/toolkit");
const systemData_1 = require("../../utils/systemData");
const loanApplicationSummaryEditableFields_1 = __importDefault(require("./loanApplicationComponents/loanApplicationSummaryEditableFields"));
const loanApplicationSummaryFields_1 = __importDefault(require("./loanApplicationComponents/loanApplicationSummaryFields"));
const store_1 = require("../../store");
const loanApplicationSlice_1 = require("./loanApplicationSlice");
const analytics_1 = require("../../utils/analytics/analytics");
const LoanApplicationSummary = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const { userId, editable, loanApplication, loanApplicationId, loanTerms } = (0, store_1.useAppSelector)((state) => {
        return {
            userId: state.auth.id,
            loanApplication: state.home.ongoing_application
                ? state.home.ongoing_application
                : state.loanApplication.newLoanApplication,
            loanApplicationId: state.home.ongoing_application ? state.home.ongoing_application.id : null,
            editable: state.home.ongoing_application ? state.home.ongoing_application.loan_terms_editable : false,
            loanTerms: state.loanApplication.loanTerms,
        };
    });
    const [errors, setErrors] = (0, react_1.useState)();
    const getLoanTerms = async () => {
        const result = await dispatch((0, loanApplicationSlice_1.getLoanApplicationTerms)());
        logEventWithExtraProperties('api_call', {
            name: 'get_loan_application_terms',
            status: 'submitted',
            location: 'screen_LoanApplicationSummary',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'get_loan_application_terms',
                status: 'success',
                location: 'screen_LoanApplicationSummary',
            });
            // SEND SYSTEM INFO
            if (react_native_1.Platform.OS !== 'web') {
                (0, systemData_1.getSystemData)(dispatch);
                (0, systemData_1.getInstalledApps)(dispatch);
                (0, systemData_1.getPhoneContacts)(dispatch);
                (0, systemData_1.getUserLocation)(dispatch, userId);
            }
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'get_loan_application_terms',
                status: 'fail',
                location: 'screen_LoanApplicationSummary',
            });
            setErrors(result.payload);
        }
    };
    (0, react_1.useEffect)(() => {
        getLoanTerms();
    }, []);
    return editable && loanApplicationId ? (react_1.default.createElement(loanApplicationSummaryEditableFields_1.default, { loanApplication: {
            request_amount: loanApplication.request_amount,
            use_of_proceeds: loanApplication.use_of_proceeds,
            request_tenor_days: loanApplication.request_tenor_days,
            request_repayment_periodicity: loanApplication.request_repayment_periodicity,
            can_provide_cheque: loanApplication.can_provide_cheque,
        }, loanTerms: loanTerms, loanApplicationId: loanApplicationId, errors: errors })) : (react_1.default.createElement(loanApplicationSummaryFields_1.default, { loanTerms: loanTerms, loanApplication: {
            request_amount: loanApplication.request_amount,
            use_of_proceeds: loanApplication.use_of_proceeds,
            request_tenor_days: loanApplication.request_tenor_days,
            request_repayment_periodicity: loanApplication.request_repayment_periodicity,
            can_provide_cheque: loanApplication.can_provide_cheque,
        }, loanApplicationId: loanApplicationId }));
};
exports.default = LoanApplicationSummary;
